export default __webpack_public_path__ + "c5fe4b8030819cb9a4297df3eed4494e.png";